import * as React from "react";

import { PageGenericError } from "@mnemonic/mui";

import { DEFAULT_ERROR_KEY, RouterAwareErrorBoundary } from "./ErrorBoundary";

export interface IInnerErrorBoundaryProps {
  children: React.ReactNode;
}
const InnerErrorBoundary = ({ children, ...rest }: IInnerErrorBoundaryProps) => (
  <RouterAwareErrorBoundary
    {...rest}
    handlers={{
      [DEFAULT_ERROR_KEY]: { Component: PageGenericError },
    }}
  >
    {children}
  </RouterAwareErrorBoundary>
);

export default InnerErrorBoundary;
